import { render, staticRenderFns } from "./cPrivacyConsent.vue?vue&type=template&id=29a4b2a3&scoped=true"
import script from "./cPrivacyConsent.vue?vue&type=script&lang=js"
export * from "./cPrivacyConsent.vue?vue&type=script&lang=js"
import style0 from "./cPrivacyConsent.vue?vue&type=style&index=0&id=29a4b2a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a4b2a3",
  null
  
)

export default component.exports